export default "__VITE_ASSET__DeXnX9rM__"